import { FormField } from '../../interfaces/FormInterfaces';
import { FORM_FIELD, Qytetet } from '../../utilities/enums';
import { inputStyling } from '../common-style-constants';
import {
  functionData,
  fushatVeprimtariseData,
} from '../../pages/Administration/ContinuousEducation/AdministrationOfParticipants/participants.constants';

const allQytetet = Object.entries(Qytetet).map(([key, value]) => ({
  label: value,
  value: key,
}));

export const PersonalDataInitialValues = (): FormField[] => [
  {
    name: 'emri',
    type: FORM_FIELD.INPUT,
    label: 'Emri',
    otherprops: {
      className: inputStyling,
    },
    disabled: true,
  },
  {
    name: 'mbiemri',
    type: FORM_FIELD.INPUT,
    label: 'Mbiemri',
    otherprops: {
      className: inputStyling,
    },
    disabled: true,
  },
  {
    name: 'atesia',
    type: FORM_FIELD.INPUT,
    label: 'Atesia',
    otherprops: {
      className: inputStyling,
    },
    disabled: false,
  },
  {
    name: 'numriPersonal',
    type: FORM_FIELD.INPUT,
    label: 'Numri Personal',
    otherprops: {
      className: inputStyling,
    },
    disabled: false,
  },
  {
    name: 'ditelindja',
    type: FORM_FIELD.DATE,
    label: 'Ditëlindja',
    otherprops: {
      // DatePicker isn't block-width/tall by default like Input/Select are.
      // className carries the border/text styling; inline style forces the
      // width + height so it matches the sibling inputs (e.g. Numri Personal).
      className: inputStyling,
      style: { width: '100%', height: 40 },
    },
    disabled: false,
  },
  {
    name: 'gjinia',
    type: FORM_FIELD.ANTD_SELECT,
    label: 'Gjinia',
    options: [
      { value: 'MASHKULL', label: 'Mashkull' },
      { value: 'FEMER', label: 'Femër' },
    ],
    otherprops: {
      className: inputStyling,
    },
    disabled: false,
  },
  {
    name: 'vendbanimi',
    type: FORM_FIELD.ANTD_SELECT,
    rules: [
      {
        required: true,
        message: 'Ju lutem zgjidhni vendbanimin!',
      },
    ],
    label: 'Vendbanimi',
    options: allQytetet,
  },
  {
    name: 'shtetesia',
    type: FORM_FIELD.ANTD_SELECT,
    rules: [
      {
        required: true,
        message: 'Ju lutem zgjidhni shtetësinë!',
      },
    ],
    label: 'Shtetësia',
    options: [
      {
        label: 'Shqiperi',
        value: 'SHQIPERI',
      },
    ],
  },
  {
    name: 'numerTelefoni',
    type: FORM_FIELD.INPUT,
    label: 'Numri i Telefonit',
    otherprops: {
      className: inputStyling,
    },
    disabled: false,
  },
  {
    name: 'funksioni',
    type: FORM_FIELD.ANTD_SELECT,
    label: 'Funksioni',
    options: functionData,
    otherprops: {
      className: inputStyling,
    },
    disabled: false,
  },
  {
    name: 'fushatVeprimtarise',
    type: FORM_FIELD.ANTD_SELECT,
    label: 'Fusha e Veprimtarisë',
    options: fushatVeprimtariseData,
    mode: 'multiple',
    otherprops: {
      className: inputStyling,
    },
    disabled: false,
  },
];
